import type { ImageProps } from '@wix/thunderbolt-components';
import { STATIC_MEDIA_URL, getData } from '@wix/image-kit';
import type { ResponsiveImageProps } from '@wix/editor-elements-definitions';

export const getResponsiveImageProps = (
  imageData: Omit<ImageProps, 'alt'>,
  targetWidth: number,
  targetHeight: number,
): ResponsiveImageProps => {
  const {
    displayMode,
    uri,
    width,
    height,
    crop,
    focalPoint,
    quality,
    upscaleMethod,
    hasAnimation,
    alignType,
    name,
    encoding,
  } = imageData;

  const {
    srcset,
    css,
    uri: src,
  } = getData(
    displayMode,
    { id: uri, width, height, name, crop, focalPoint },
    {
      width: targetWidth,
      height: targetHeight,
      alignment: alignType,
    },
    {
      focalPoint,
      name,
      quality: quality?.quality,
      upscaleMethod,
      hasAnimation,
      useSrcset: true,
      encoding,
    },
  );

  const srcsetWithPrefix = srcset?.dpr?.map((s: string) =>
    /^[a-z]+:/.test(s) ? s : `${STATIC_MEDIA_URL}${s}`,
  );

  const fallbackSrc = `${STATIC_MEDIA_URL}${src}`;
  const srcsetString = srcsetWithPrefix?.join(', ');

  return {
    fallbackSrc,
    srcset: srcsetString,
    css,
  };
};
